export var PageActions;
(function (PageActions) {
  let SetTitle = /*#__PURE__*/(() => {
    class SetTitle {
      static {
        this.type = '[Page] SetTitle';
      }
      constructor(title) {
        this.title = title;
      }
    }
    return SetTitle;
  })();
  PageActions.SetTitle = SetTitle;
  let SetMeta = /*#__PURE__*/(() => {
    class SetMeta {
      static {
        this.type = '[Page] SetMeta';
      }
      constructor(data, resetMeta = true) {
        this.data = data;
        this.resetMeta = resetMeta;
      }
    }
    return SetMeta;
  })();
  PageActions.SetMeta = SetMeta;
  let SetIsInitialRoute = /*#__PURE__*/(() => {
    class SetIsInitialRoute {
      static {
        this.type = '[Page] SetIsInitialRoute';
      }
      constructor(isInitialRoute) {
        this.isInitialRoute = isInitialRoute;
      }
    }
    return SetIsInitialRoute;
  })();
  PageActions.SetIsInitialRoute = SetIsInitialRoute;
  let SetInitialRouteParams = /*#__PURE__*/(() => {
    class SetInitialRouteParams {
      static {
        this.type = '[Page] SetInitialRouteParams';
      }
      constructor(params) {
        this.params = params;
      }
    }
    return SetInitialRouteParams;
  })();
  PageActions.SetInitialRouteParams = SetInitialRouteParams;
})(PageActions || (PageActions = {}));
// export UserActions;